import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Carbon first, so the not-yet-converted pages' legacy rules still win over it.
// `legacy.css` shrinks each phase and is deleted when the last page converts.
import './styles/carbon.scss';
import './styles/legacy.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('#root element is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
